var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b;
import { CategoryOverviewSection, DashboardCategory, DashboardEvolutionEnum, WidgetCategory } from "./enums";
import { generateRoute } from "@js/common/helpers";
import { seasonShortNames } from "./data";
import { toast } from "react-toastify";
export var DEFAULT_DASHBOARD_ERROR = 'An error occurred. '
    + 'Please try again or contact us at support@tag-walk.com if the problem persists.';
export var noDataAvailable = 'No data available';
export var HERO_DOT_COLOUR_COUNT = 6;
export var joinFilters = function (parts) {
    return parts.filter(Boolean).join(' · ');
};
export var getSelectTheme = function (theme) {
    return __assign(__assign({}, theme), { colors: __assign(__assign({}, theme.colors), { primary: '#EFF1F1', primary25: '#F8FAFA' }) });
};
export var buildParameterSelectStyles = function (isDarkMenu, styles) { return (__assign(__assign({}, styles), { menuPortal: function (base, state) {
        var inherited = (styles === null || styles === void 0 ? void 0 : styles.menuPortal) ? styles.menuPortal(base, state) : base;
        return __assign(__assign({}, inherited), { zIndex: 'var(--z-index-foreground)' });
    }, input: function (base, state) {
        var inherited = (styles === null || styles === void 0 ? void 0 : styles.input) ? styles.input(base, state) : base;
        return __assign(__assign({}, inherited), { color: isDarkMenu ? 'var(--white)' : inherited.color });
    }, menu: function (base, state) {
        var inherited = (styles === null || styles === void 0 ? void 0 : styles.menu) ? styles.menu(base, state) : base;
        return __assign(__assign({}, inherited), { fontSize: 'calc(var(--filter-pill-base-size) * .75)', width: 'max-content', overflow: 'hidden', backgroundColor: isDarkMenu ? 'var(--db-ink)' : 'var(--white)', border: isDarkMenu ? '1px solid rgba(255, 255, 255, .1)' : '1px solid var(--db-sand)', borderRadius: isDarkMenu ? 'calc(var(--space-unit) * 5)' : 'var(--space-xs)', boxShadow: isDarkMenu ? '0 8px 32px rgba(0, 0, 0, .35)' : '0 4px 11px rgba(0, 0, 0, .1)' });
    }, menuList: function (base, state) {
        var inherited = (styles === null || styles === void 0 ? void 0 : styles.menuList) ? styles.menuList(base, state) : base;
        if (isDarkMenu) {
            return __assign(__assign({}, inherited), { padding: 'var(--space-xs)', overflowX: 'hidden', scrollbarWidth: 'none', '::-webkit-scrollbar': { display: 'none' } });
        }
        return __assign(__assign({}, inherited), { padding: 0, overflowX: 'hidden', scrollbarWidth: 'thin', scrollbarColor: 'var(--db-sand) transparent', '::-webkit-scrollbar': { width: '6px' }, '::-webkit-scrollbar-button': { display: 'none' }, '::-webkit-scrollbar-track': { background: 'transparent' }, '::-webkit-scrollbar-thumb': { background: 'var(--db-sand)', borderRadius: '999px' }, '::-webkit-scrollbar-thumb:hover': { background: 'var(--db-muted)' } });
    }, option: function (base, state) {
        var inherited = (styles === null || styles === void 0 ? void 0 : styles.option) ? styles.option(base, state) : base;
        if (isDarkMenu) {
            return __assign(__assign({}, inherited), { cursor: 'pointer', color: 'var(--white)', backgroundColor: 'transparent', padding: 'var(--space-xs) var(--space-default)', borderRadius: 'calc(var(--space-unit) * 3.5)', whiteSpace: 'nowrap', textAlign: 'left', '&:hover': { backgroundColor: 'rgba(255, 255, 255, .08)', color: 'var(--white)' } });
        }
        var focusedStyles = state.isFocused
            ? { backgroundColor: 'var(--db-blue)', color: 'var(--db-gold)' }
            : { backgroundColor: 'transparent', color: 'var(--black)' };
        return __assign(__assign(__assign(__assign({}, inherited), { cursor: 'pointer', padding: 'var(--space-xs) var(--space-s)', whiteSpace: 'nowrap', textAlign: 'left' }), focusedStyles), { '&:hover': { backgroundColor: 'var(--db-blue)', color: 'var(--db-gold)' } });
    } })); };
export var pageSlugFromCategory = (_a = {},
    _a[DashboardCategory.Trends] = 'trend-focus',
    _a[DashboardCategory.Seasons] = 'season-focus',
    _a[DashboardCategory.Brands] = 'brand-focus',
    _a[DashboardCategory.Traffic] = 'traffic',
    _a[DashboardCategory.Top20Brands] = 'custom-top-20-brands',
    _a);
export var pageNameFromCategory = (_b = {},
    _b[DashboardCategory.Trends] = 'Trend focus',
    _b[DashboardCategory.Seasons] = 'Season focus',
    _b[DashboardCategory.Brands] = 'Brand focus',
    _b[DashboardCategory.Traffic] = 'Industry & Consumer Insights',
    _b[DashboardCategory.Top20Brands] = 'Custom top 20 brands',
    _b);
export var pillsColorsVariables = [
    '--color-dashboard-pill-1',
    '--color-dashboard-pill-2',
    '--color-dashboard-pill-3',
    '--color-dashboard-pill-4',
    '--color-dashboard-pill-5',
    '--color-dashboard-pill-6',
];
export var pillsColors = pillsColorsVariables.map(function (v) { return "var(" + v + ")"; });
export var pillsColorsVariablesTop20Brands = Array.from({ length: 20 }, function (_, i) { return "--color-dashboard-top-20-brands-pill-" + (i + 1); });
export var pillsColorsTop20Brands = pillsColorsVariablesTop20Brands.map(function (v) { return "var(" + v + ")"; });
;
export var cities = [
    { title: 'Paris', color: "var(--color-dashboard-paris)" },
    { title: 'Milan', color: "var(--color-dashboard-milan)" },
    { title: 'New York', color: "var(--color-dashboard-new-york)" },
    { title: 'London', color: "var(--color-dashboard-london)" },
];
export var updateParamInQuery = function (name, value) {
    var url = new URL(window.location.href);
    url.searchParams.set(name, value);
    history.pushState(null, '', url);
    window.dispatchEvent(new Event('urlchange'));
};
export var removeParamInQuery = function (name) {
    var url = new URL(window.location.href);
    url.searchParams.delete(name);
    history.pushState(null, '', url);
};
export var getTooltipAnchor = function (widgetCategory) {
    return widgetCategory === WidgetCategory.MostViewedLooks
        ? 'tooltip-most-viewed-looks'
        : 'tooltip-most-saved-to-moodboard';
};
export var getMVLEndpoint = function (category) {
    if (category === DashboardCategory.Brands) {
        return 'api_dashboard_brand_most_viewed_look_index';
    }
    return 'api_dashboard_most_viewed_look_index';
};
export var getMSTMEndpoint = function (category) {
    return 'api_dashboard_brand_most_saved_to_moodboard_index';
};
export var getCategoryOverviewEndpoint = function (section) {
    if (section === CategoryOverviewSection.RunwayShare) {
        return 'api_dashboard_category_overview_runway_share';
    }
    if (section === CategoryOverviewSection.Moodboards) {
        return 'api_dashboard_category_overview_moodboards';
    }
    return 'api_dashboard_category_overview_searches';
};
export var handleFirstCellValue = function (section) {
    if (section === CategoryOverviewSection.RunwayShare) {
        return 'share_of_collection_v2';
    }
    if (section === CategoryOverviewSection.Searches) {
        return 'search_percentage_v2';
    }
    return 'share_of_moodboards_v2';
};
export var handleSecondCellValue = function (section) {
    if (section === CategoryOverviewSection.RunwayShare) {
        return 'yoy_evol_share_of_collection_v2';
    }
    return 'percentage_evolution_v2';
};
export var handleTop20Arrows = function (value) {
    if (String(value).match(/^-/)) {
        return 'triangle triangle-down';
    }
    if (/^\d/.test(value)) {
        return 'triangle triangle-up';
    }
    return '';
};
export var getRankingTextColor = function (value) {
    if (value == null) {
        return '';
    }
    var strValue = String(value);
    if (strValue === 'SAME') {
        return 'dashboard-blue';
    }
    if (strValue === 'NEW') {
        return 'dashboard-yellow';
    }
    if (strValue.startsWith('-')) {
        return 'color-error';
    }
    return 'color-success';
};
export var handleKpiArrows = function (value) {
    if (String(value).match(/^\+/)) {
        return 'triangle triangle-up';
    }
    if (String(value).match(/^-/)) {
        return 'triangle triangle-down';
    }
    if (value === '0%' || value === DashboardEvolutionEnum.Stable) {
        return 'neutral';
    }
    return '';
};
export var getSeasonShortName = function (seasonName) {
    var _a;
    return (_a = seasonShortNames.find(function (item) { return item.name === seasonName; })) === null || _a === void 0 ? void 0 : _a.shortName;
};
export var redirectToFocus = function (dashboardCategory, dynamicValue) {
    var _a;
    if (dashboardCategory === DashboardCategory.Brands) {
        window.location.href = generateRoute('data_dashboard_show', {
            slug: 'brand-focus',
            brand: dynamicValue.currentValue
        }, false);
        return;
    }
    if (dashboardCategory === DashboardCategory.Trends) {
        window.location.href = generateRoute('data_dashboard_show', {
            slug: 'trend-focus',
            trend: dynamicValue.currentValue
        }, false);
        return;
    }
    var fullName = (_a = seasonShortNames.find(function (item) { return item.shortName === dynamicValue.currentValue; })) === null || _a === void 0 ? void 0 : _a.name;
    if (!fullName) {
        toast.error(DEFAULT_DASHBOARD_ERROR);
        return;
    }
    window.location.href = generateRoute('data_dashboard_show', {
        slug: 'season-focus',
        season: fullName
    }, false);
};
function isParameterHook(param) {
    return param !== null && typeof param === "object" && "currentValue" in param;
}
export var parametersToQuery = function (params) {
    var query = {};
    Object.entries(params).forEach(function (_a) {
        var key = _a[0], param = _a[1];
        if (param === undefined || param === null) {
            return;
        }
        if (isParameterHook(param)) {
            query[key] = param.currentValue;
        }
        else {
            query[key] = param;
        }
    });
    return query;
};
export function buildCities(city) {
    if (city === 'All cities') {
        return ['New York', 'London', 'Milan', 'Paris'];
    }
    return [city];
}
export function normalizeFilename(filename) {
    var _a;
    if (!filename) {
        return filename;
    }
    return filename.startsWith('http') ? (_a = filename.split('/').pop()) !== null && _a !== void 0 ? _a : filename : filename;
}
